module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_3_preview.70994674.jpg";